// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"f44d27d8","112":"17f757de","264":"c29aedf2","310":"33e74595","338":"ba81e0d0","375":"52490c46","416":"d709b78a","719":"35af3aad","779":"294c1111","805":"606d69d5","932":"e0ac0aee","957":"995fb785","976":"e5edd504"}[chunkId] + ".chunk.js";
};